import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { useSelector, useDispatch } from "react-redux";
import { SearchDesktop } from "./SearchDesktop";
import { TableDanhSach } from "./TableDanhSach";
import { BtnInDanhSach } from "./InDanhSach/BtnInDanhSach";
import { BtnXuatExcel } from "./XuatExcel/BtnXuatExcel";
import { BtnThemMoiChiNgoaiLe } from "./ThemMoi/ThemMoiChiNgoaiLe/BtnThemMoiChiNgoaiLe";
import { BtnThemMoiThuNgoaiLe } from "./ThemMoi/ThemMoiThuNgoaiLe/BtnThemMoiThuNgoaiLe";
import StoreApi from "../../../service/phanQuyenApi";
import { SearchBarMobile } from "./SearchBarMobile";
import LayoutV2 from "containers/LayoutV2";

export const QuanLyThuChiNgoaiLe = () => {
  const initPhanQuyen = {
    thuchingoaile: false,
    thuchingoaile_indanhsachphieuthuchingoaile: false,
    thuchingoaile_inphieuthungoaile: false,
    thuchingoaile_inphieuchingoaile: false,
    thuchingoaile_suaphieuthuchingoaile: false,
    thuchingoaile_themmoiphieuchingoaile: false,
    thuchingoaile_themmoiphieuthungoaile: false,
    thuchingoaile_xoaphieuthuchingoaile: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenThuChiNgoaiLe().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        thuchingoaile: response.data.thuchingoaile,
        thuchingoaile_indanhsachphieuthuchingoaile:
          response.data.thuchingoaile_indanhsachphieuthuchingoaile,
        thuchingoaile_inphieuthungoaile:
          response.data.thuchingoaile_inphieuthungoaile,
        thuchingoaile_suaphieuthuchingoaile:
          response.data.thuchingoaile_suaphieuthuchingoaile,
        thuchingoaile_themmoiphieuchingoaile:
          response.data.thuchingoaile_themmoiphieuchingoaile,
        thuchingoaile_themmoiphieuthungoaile:
          response.data.thuchingoaile_themmoiphieuthungoaile,
        thuchingoaile_xoaphieuthuchingoaile:
          response.data.thuchingoaile_xoaphieuthuchingoaile,
        thuchingoaile_inphieuchingoaile:
          response.data.thuchingoaile_inphieuchingoaile,
      });
    });
  };

  useEffect(() => {
    document.title = "Thu chi ngoài lề | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);
  return (
    <LayoutV2>
      {phanQuyen.thuchingoaile && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-logo-quan-ly-thu-chi.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Thu/ Chi ngoài lề</h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            {phanQuyen.thuchingoaile_indanhsachphieuthuchingoaile && (
                              <li>
                                <BtnInDanhSach />
                              </li>
                            )}
                            <li>
                              <BtnXuatExcel />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchDesktop />
                  </div>
                </div>
                <SearchBarMobile />
                <div className="card border-light mb-1 hide-table-main show-mobile-main hidden-des-main card-v2">
                  <div className="card-body card-body-v2  mb-1">
                    <div>
                      <span > 
                        {phanQuyen.thuchingoaile_themmoiphieuthungoaile && (
                          <BtnThemMoiThuNgoaiLe />
                        )}
                      </span>
                      <span   style={{ marginLeft: "2rem" }}>
                        {phanQuyen.thuchingoaile_themmoiphieuchingoaile && (
                          <BtnThemMoiChiNgoaiLe />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSach
            themThu={phanQuyen.thuchingoaile_themmoiphieuthungoaile}
            themChi={phanQuyen.thuchingoaile_themmoiphieuchingoaile}
            inPhieuThu={phanQuyen.thuchingoaile_inphieuthungoaile}
            inPhieuChi={phanQuyen.thuchingoaile_inphieuchingoaile}
            suaPhieu={phanQuyen.thuchingoaile_suaphieuthuchingoaile}
            xoaPhieu={phanQuyen.thuchingoaile_xoaphieuthuchingoaile}
          />
        </div>
      )}
      {!phanQuyen.thuchingoaile && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull
                      title="Thu chi ngoài lề"
                      icon1="fas fa-donate"
                    />
                    <div className="col-sm-12 col-md-3 d-flex just-end hidden-mobile-main"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
